
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/landings/[campaign]",
      function () {
        return require("private-next-pages/landings/[campaign]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/landings/[campaign]"])
      });
    }
  